import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
    showSuccessNotification: false
}

export const idxReducer = (state=initialState, action) => {
    switch(action.type){
        case ActionTypes.IDX_NOTIFICATION: 
            return{
                ...state, 
                showSuccessNotification: action.payload
            }
        default: 
            return state
    }
}